import React, { useEffect, useState } from "react";
import Video1 from "@/assets/videos/cust-test.mp4";
import Video2 from "@/assets/videos/about-cancer-care.mp4";
const user_key = import.meta.env.VITE_AUTH_KEY;

import Video1Img from "@/assets/images/Testimonial.png";
import Video2Img from "@/assets/images/About.png";
import Video3Img from "@/assets/images/Value_Added.png";
import Video4Img from "@/assets/images/Role_Play.png";

import Video1ImgM from "@/assets/images/Testimonial_m.png";
import Video2ImgM from "@/assets/images/About_m.png";
import Video3ImgM from "@/assets/images/Value_Added_m.png";
import Video4ImgM from "@/assets/images/Role_Play_m.png";

import PopupModal from "../ui/Popup";
import {
  encryptData,
  decodedPlaload,
  decryptData,
  getTokenExp,
} from "@/Services/req_res_decode_encode";
import { API } from "../../Services/apimethod.js";
import toast from "react-hot-toast";

const Videos = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [openOneComment, setOpenOneComment] = useState<boolean>(false);
  const [comments, setComments] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [likeDislike, setLikeDislike] = useState<any>({
    "Customer Testimonials": { like: 0, dislike: 0 },
    "About Cancer Care": { like: 0, dislike: 0 },
  });

  const [commentsC, setCommentsC] = useState<any>({
    "Customer Testimonials": { count: 0 },
    "About Cancer Care": { count: 0 },
  });

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsDesktop(window.innerWidth >= 1024);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const getUSer = () => {
    const auth = localStorage.getItem(user_key);
    if (!auth) {
      return "";
    } else {
      let d = decodedPlaload(auth);
      return d?.user?.login_id;
    }
  };

  const getLikeDislike = async (title: string) => {
    const payload = encryptData({
      post_title: title,
    });
    const count = await API.CreateMethod("get_post_reaction", { payload });
    if (count.status == 200) {
      const counts = decryptData(count.data);
      setLikeDislike((prev) => ({
        ...prev,
        [title]: {
          like: counts.data.totalLikes,
          dislike: counts.data.totalDislikes,
        },
      }));
    }
  };

  const getCommentCount = async (title: string) => {
    const payload = encryptData({
      post_title: title,
    });
    const response = await API.CreateMethod("get_comments", { payload });
    if (response.status == 200) {
      const data = decryptData(response.data);
      setCommentsC((prev) => ({
        ...prev,
        [title]: {
          count: data.data.totalComments || data.data.length || 0,
        },
      }));
    }
  };
  useEffect(() => {
    getCommentCount("Customer Testimonials");
    getCommentCount("About Cancer Care");
    getLikeDislike("Customer Testimonials");
    getLikeDislike("About Cancer Care");
  }, []);

  const onSubmitComments = async () => {
    if (getTokenExp()) {
      localStorage.clear();
      toast.error("Your login is expired!");
      setTimeout(() => {
        window.location.href = import.meta.env.VITE_LOGINURL;
      }, 2000);
      return false;
    }

    const payload = encryptData({
      user_id: getUSer(),
      comment: comments,
      post_title: title,
    });
    if (!comments) {
      toast.error("feedback is required!");
      return false;
    }
    const comment = await API.CreateMethod("add_comment", { payload });
    if (comment.status == 201) {
      toast.success("feedback submitted successfully!");
      setOpenOneComment(false);
      setComments("");
      setTitle("");
      getCommentCount(title);
    } else {
      toast.error("Somthing went wrong");
    }
  };

  const onLikeDislike = async (like: number, dislike: number, titles: string) => {
    if (getTokenExp()) {
      localStorage.clear();
      toast.error("Your login is expired!");
      setTimeout(() => {
        window.location.href = import.meta.env.VITE_LOGINURL;
      }, 2000);
      return false;
    }

    const payload = encryptData({
      user_id: getUSer(),
      like: like,
      dislike: dislike,
      post_title: titles,
    });
    const res = await API.CreateMethod("react_to_post", { payload });
    if (res.status == 200) {
      getLikeDislike(titles);
    }
  };

  const onClickRate = async (titles: string) => {
    if (getTokenExp()) {
      localStorage.clear();
      toast.error("Your login is expired!");
      setTimeout(() => {
        window.location.href = import.meta.env.VITE_LOGINURL;
      }, 2000);
      return false;
    }
    setOpen(true);
    const payload = encryptData({
      user_id: getUSer(),
      post_title: titles,
    });
    const click = await API.CreateMethod("track_cancer_video_click", { payload });
  };

  return (
    <div className="videos-section">
      <h2 className="videos-title">Watch & Pitch</h2>
      <div className="videos-grid">
        <a rel="noopener noreferrer" className="video-tile">
          <div
            className="video-thumb"
            style={{ cursor: "pointer" }}
            onClick={() => {
              onClickRate("Customer Testimonials");
              setSelectedVideo(Video1);
            }}
          >
            <img src={isDesktop ? Video1Img : Video1ImgM} alt="Customer Testimonials" />
            <div className="video-play-btn">▶</div>
          </div>
          <div className="video-caption">
            <strong>Customer Testimonials</strong>
          </div>
          <div className="video-reactions">
            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => onLikeDislike(1, 0, "Customer Testimonials")}
              >
                👍
              </span>
              <span className="reaction-count">
                {likeDislike["Customer Testimonials"]?.like ?? 0}
              </span>
            </div>

            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => onLikeDislike(0, 1, "Customer Testimonials")}
              >
                👎
              </span>
              <span className="reaction-count">
                {likeDislike["Customer Testimonials"]?.dislike ?? 0}
              </span>
            </div>

            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => {
                  setTitle("Customer Testimonials");
                  setOpenOneComment(true);
                }}
              >
                💬
              </span>
              <span className="reaction-count">
                {commentsC["Customer Testimonials"]?.count || 0}
              </span>
            </div>
          </div>
        </a>

        <a rel="noopener noreferrer" className="video-tile">
          <div
            className="video-thumb"
            style={{ cursor: "pointer" }}
            onClick={() => {
              onClickRate("About Cancer Care");
              setSelectedVideo(Video2);
            }}
          >
            <img src={isDesktop ? Video2Img : Video2ImgM} alt="About Cancer Care" />
            <div className="video-play-btn">▶</div>
          </div>
          <div className="video-caption">
            <strong>About Cancer Care</strong>
          </div>
          <div className="video-reactions">
            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => onLikeDislike(1, 0, "About Cancer Care")}
              >
                👍
              </span>
              <span className="reaction-count">{likeDislike["About Cancer Care"]?.like ?? 0}</span>
            </div>

            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => onLikeDislike(0, 1, "About Cancer Care")}
              >
                👎
              </span>
              <span className="reaction-count">
                {likeDislike["About Cancer Care"]?.dislike ?? 0}
              </span>
            </div>
            <div className="reaction-wrapper">
              <span
                className="reaction-btn"
                onClick={() => {
                  setTitle("About Cancer Care");
                  setOpenOneComment(true);
                }}
              >
                💬
              </span>
              <span className="reaction-count">{commentsC["About Cancer Care"]?.count || 0}</span>
            </div>
          </div>
        </a>
        <a className="video-tile video-disabled">
          <div className="coming-badge">Coming Soon</div>
          <div className="video-thumb">
            <img src={isDesktop ? Video3Img : Video3ImgM} alt="How Value Added Service Works" />
            <div className="video-play-btn">▶</div>
          </div>
          <div className="video-caption">
            <strong>How Value Added Service Works</strong>
          </div>
          <div className="video-reactions">
            <span className="reaction-btn">👍</span>
            <span className="reaction-btn">👎</span>
            <span className="reaction-btn">💬</span>
          </div>
        </a>
        <a className="video-tile video-disabled">
          <div className="coming-badge">Coming Soon</div>
          <div className="video-thumb">
            <img src={isDesktop ? Video4Img : Video4ImgM} alt="Role Play Video" />
            <div className="video-play-btn">▶</div>
          </div>
          <div className="video-caption">
            <strong>Role Play Video</strong>
          </div>
          <div className="video-reactions">
            <span className="reaction-btn">👍</span>
            <span className="reaction-btn">👎</span>
            <span className="reaction-btn">💬</span>
          </div>
        </a>
      </div>
      <PopupModal isOpen={open} setOpen={setOpen} title="videos">
        <video
          controls
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            borderRadius: "6px",
            display: "block",
          }}
        >
          <source src={selectedVideo} type="video/mp4" />
          Your browser does not support video playback.
        </video>
      </PopupModal>

      <PopupModal isOpen={openOneComment} setOpen={setOpenOneComment} title="videoComments">
        <h2 className="section-title-comment">
          Submit your feedback <span style={{ color: "red" }}> *</span>
        </h2>
        <textarea
          value={comments}
          placeholder="Your feedback.."
          onChange={(e) => {
            if (e.target.value.length <= 500) {
              setComments(e.target.value);
            }
          }}
          style={{
            width: "100%",
            height: "100px",
            padding: "10px",
            fontSize: "16px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
        <div style={{ height: "5px" }}>
          <small style={{ color: "#666" }}>Maximum 500 characters({comments.length}/500)</small>
        </div>
        <button
          onClick={onSubmitComments}
          style={{ width: "100px", marginTop: 30 }}
          className="btn-1 btn-purple"
        >
          Submit
        </button>
      </PopupModal>
    </div>
  );
};

export default Videos;
